"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledText = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/styled-text"));

var _button = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/button"));

var _AlertCircleIcon = require("@zipwhip/zipkit/dist/icons/AlertCircleIcon");

var _constants = require("../../constants");

var _groupTitles;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var GROUP_BUSINESS_INFO = 'BUSINESS_INFO';
var GROUP_BUSINESS_LOCATION = 'BUSINESS_LOCATION';
var GROUP_CONTACT_INFO = 'CONTACT_INFO';
var groupTitles = (_groupTitles = {}, _defineProperty(_groupTitles, GROUP_BUSINESS_INFO, 'Business Info'), _defineProperty(_groupTitles, GROUP_BUSINESS_LOCATION, 'Business Location'), _defineProperty(_groupTitles, GROUP_CONTACT_INFO, 'Contact Info'), _groupTitles);

var getFieldsInfo = function getFieldsInfo(dropdownValues) {
  return [{
    name: 'businessType',
    label: 'Business Type',
    dropdownValues: dropdownValues[_constants.LOOKUP_KEY_BUSINESS_TYPE],
    group: GROUP_BUSINESS_INFO
  }, {
    name: 'businessNameDisplay',
    label: 'Company Name',
    group: GROUP_BUSINESS_INFO
  }, {
    name: 'businessNameLegal',
    label: 'Company Name (Legal)',
    group: GROUP_BUSINESS_INFO
  }, {
    name: 'businessVertical',
    label: 'Industry or Vertical',
    dropdownValues: dropdownValues[_constants.LOOKUP_KEY_BUSINESS_VERTICAL],
    group: GROUP_BUSINESS_INFO
  }, {
    name: 'taxId',
    label: 'EIN (Canadian BN for Canada)',
    group: GROUP_BUSINESS_INFO,
    requiredOnlyFor: [_constants.BUSINESS_TYPE_PUBLIC, _constants.BUSINESS_TYPE_PRIVATE, _constants.BUSINESS_TYPE_NON_PROFIT, _constants.BUSINESS_TYPE_SOLE_PROP_TAXID]
  }, {
    name: 'businessStockExchange',
    label: 'Stock Exchange',
    dropdownValues: dropdownValues[_constants.LOOKUP_KEY_STOCK_EXCHANGE],
    group: GROUP_BUSINESS_INFO,
    requiredOnlyFor: [_constants.BUSINESS_TYPE_PUBLIC]
  }, {
    name: 'businessStockSymbol',
    label: 'Stock Symbol',
    group: GROUP_BUSINESS_INFO,
    requiredOnlyFor: [_constants.BUSINESS_TYPE_PUBLIC]
  }, {
    name: 'addressCountry',
    label: 'Country',
    dropdownValues: _constants.COUNTRY_OPTIONS,
    group: GROUP_BUSINESS_LOCATION
  }, {
    name: 'addressState',
    label: 'State',
    // TODO: Province for CA?
    dropdownValues: [].concat(_toConsumableArray(_constants.US_STATES_OPTIONS), _toConsumableArray(_constants.CANADIAN_PROVINCES_OPTIONS)),
    group: GROUP_BUSINESS_LOCATION
  }, {
    name: 'addressCity',
    label: 'City',
    group: GROUP_BUSINESS_LOCATION
  }, {
    name: 'addressStreet',
    label: 'Street',
    group: GROUP_BUSINESS_LOCATION
  }, {
    name: 'addressPostalCode',
    label: 'Postal Code',
    // TODO: ZIP code for US?
    group: GROUP_BUSINESS_LOCATION
  }, {
    name: 'contactName',
    label: 'Contact Name',
    group: GROUP_CONTACT_INFO
  }, {
    name: 'contactPhone',
    label: 'Contact Phone',
    group: GROUP_CONTACT_INFO
  }, {
    name: 'contactEmail',
    label: 'Contact Email',
    group: GROUP_CONTACT_INFO
  }, {
    name: 'brandWebsite',
    label: 'Brand website',
    group: GROUP_BUSINESS_INFO,
    requiredOnlyFor: [_constants.BUSINESS_TYPE_PUBLIC]
  }];
};

var FieldItem = function FieldItem(_ref) {
  var fieldInfo = _ref.fieldInfo,
      dontDisplay = _ref.dontDisplay;

  if (dontDisplay) {
    return null;
  }

  var value = fieldInfo.value,
      label = fieldInfo.label,
      dropdownValues = fieldInfo.dropdownValues;
  var displayValue = value;
  var missingFieldValue = false; // for dropdown fields, grab the actual display value from the dropdown info

  if (dropdownValues) {
    var item = dropdownValues.find(function (val, i) {
      return val.value === value;
    });
    displayValue = item && item.label;
  }

  if (!displayValue) {
    displayValue = 'Field Required';
    missingFieldValue = true;
  }

  return (
    /*#__PURE__*/
    _react.default.createElement("div", null,
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      className: "mb-5",
      type: "base",
      secondary: true
    }, label),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      className: (0, _classnames.default)('mb-20', _defineProperty({}, "".concat(_constants.STYLE_BASE, "_missingFieldValue"), missingFieldValue))
    }, displayValue))
  );
}; // this component will show when on DRAFT or SUBMITTED ("PENDING") mode


var ProcessSummary = function ProcessSummary(_ref2) {
  var ctaAction = _ref2.ctaAction,
      data = _ref2.data,
      dropdownValues = _ref2.dropdownValues,
      hasSavedDraft = _ref2.hasSavedDraft,
      hasSubmitted = _ref2.hasSubmitted,
      showReadOnlySummary = _ref2.showReadOnlySummary;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      displayFields = _useState2[0],
      setDisplayFields = _useState2[1];

  var getFieldsValues = function getFieldsValues() {
    var fieldsData = getFieldsInfo(dropdownValues).map(function (item, i) {
      return _objectSpread(_objectSpread({}, item), {}, {
        value: data[item.name]
      });
    }).filter(Boolean);
    getGroupedFields(fieldsData);
  };

  var getGroupedFields = function getGroupedFields(fieldsData) {
    var _groupedFields;

    var groupedFields = (_groupedFields = {}, _defineProperty(_groupedFields, GROUP_BUSINESS_INFO, []), _defineProperty(_groupedFields, GROUP_BUSINESS_LOCATION, []), _defineProperty(_groupedFields, GROUP_CONTACT_INFO, []), _groupedFields);
    fieldsData.forEach(function (field) {
      groupedFields[field.group].push(field);
    });
    setDisplayFields(groupedFields);
  };

  var renderFields = function renderFields(groupedFields) {
    var groupsNames = Object.keys(groupedFields);
    return groupsNames.map(function (name, i) {
      return (
        /*#__PURE__*/
        _react.default.createElement("div", {
          key: i
        },
        /*#__PURE__*/
        _react.default.createElement(_styledText.default, {
          className: "mb-20",
          type: "h3"
        }, groupTitles[name]), groupedFields[name].map(function (item, i) {
          var dontDisplay = false; // handle conditional display based on business type value

          if (data.businessType && item.requiredOnlyFor && !item.requiredOnlyFor.includes(data.businessType)) {
            dontDisplay = true;
          } else {// what do we do if they haven't selected businessType yet?
            // at the moment we show ALL fields in this case
          }

          return (
            /*#__PURE__*/
            _react.default.createElement(FieldItem, {
              key: i,
              fieldInfo: item,
              dontDisplay: dontDisplay
            })
          );
        }))
      );
    });
  };

  var getParsedDate = function getParsedDate(dateValue, country) {
    var _Date$toLocaleDateStr = new Date(dateValue).toLocaleDateString('en-US').split('/'),
        _Date$toLocaleDateStr2 = _slicedToArray(_Date$toLocaleDateStr, 3),
        month = _Date$toLocaleDateStr2[0],
        date = _Date$toLocaleDateStr2[1],
        year = _Date$toLocaleDateStr2[2];

    if (!month || !date || !year) {
      return;
    }

    if (!country || country === 'US') {
      return "".concat(month, "/").concat(date, "/").concat(year.slice(2));
    }

    return "".concat(date, "/").concat(month, "/").concat(year.slice(2));
  };

  (0, _react.useEffect)(function () {
    getFieldsValues(); // eslint-disable-next-line
  }, []);
  return (
    /*#__PURE__*/
    _react.default.createElement("div", {
      className: "".concat(_constants.STYLE_BASE, "_summary")
    },
    /*#__PURE__*/
    _react.default.createElement("div", {
      className: (0, _classnames.default)(["".concat(_constants.STYLE_BASE, "_summaryBox")], _defineProperty({}, "".concat(_constants.STYLE_BASE, "_summaryBox_Submitted"), hasSubmitted))
    }, hasSavedDraft ?
    /*#__PURE__*/
    _react.default.createElement(_react.Fragment, null,
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      className: "mb-20",
      type: "base"
    },
    /*#__PURE__*/
    _react.default.createElement("span", {
      className: "".concat(_constants.STYLE_BASE, "_summaryBoxIconRow")
    },
    /*#__PURE__*/
    _react.default.createElement(_AlertCircleIcon.AlertCircleIcon, {
      size: "24",
      color: "#FF8C50"
    }), ' ',
    /*#__PURE__*/
    _react.default.createElement("strong", null, "Finish Registration by March 1rst, 20201"))),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      className: "mb-20",
      type: "base"
    },
    /*#__PURE__*/
    _react.default.createElement("span", null, "Status: ",
    /*#__PURE__*/
    _react.default.createElement("strong", null, "INCOMPLETE"))),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      className: "mb-20",
      type: "base"
    }, "Complete the 10DLC registration process to ensure that your account is registered for business texting. Continue the registration process by filling out all required fields and clicking Submit."),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      bold: true,
      type: "base"
    }, "Submit your business information before March 1 to avoid future\u202Fservice disruption and certain 10DLC\u202Ffees.")) :
    /*#__PURE__*/
    _react.default.createElement(_react.Fragment, null,
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      bold: true,
      className: "mb-20",
      type: "base"
    }, "10DLC Registration Submitted"),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      type: "base"
    },
    /*#__PURE__*/
    _react.default.createElement("span", null, "Status: ",
    /*#__PURE__*/
    _react.default.createElement("strong", null, "Submitted"))), data.dateCreated &&
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      type: "base"
    },
    /*#__PURE__*/
    _react.default.createElement("span", null, "Submitted Date:", ' ',
    /*#__PURE__*/
    _react.default.createElement("strong", null, " ", getParsedDate(data.dateCreated, data.addressCountry)))), data.dateUpdated &&
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      className: "mb-20",
      type: "base"
    },
    /*#__PURE__*/
    _react.default.createElement("span", null, "Last Update:", ' ',
    /*#__PURE__*/
    _react.default.createElement("strong", null, getParsedDate(data.dateUpdated, data.addressCountry)))),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      className: "mb-20",
      type: "base"
    }, "That\u2019s all you need to do! We\u2019ll take care of the rest, including annual registration renewal. You are free to make updates to your registration details.")), !showReadOnlySummary &&
    /*#__PURE__*/
    _react.default.createElement(_button.default, {
      className: "".concat(_constants.STYLE_BASE, "_summaryButton"),
      secondary: hasSubmitted,
      onClick: ctaAction
    }, hasSavedDraft ? 'Finish Registration' : 'Update info')), renderFields(displayFields))
  );
};

var _default = ProcessSummary;
exports.default = _default;